import { useState } from 'react'

export type ViewType = 'chart' | 'table'

export function useViewToggle(initialView: ViewType = 'chart') {
    const [view, setView] = useState<ViewType>(initialView)

    const toggleView = () => {
        setView(view === 'chart' ? 'table' : 'chart')
    }

    return {
        view,
        setView,
        toggleView,
    }
}
